import { MetaTags, ZeroStatePage } from '@devd-client/devd/components';
import MetricDetails from '.';
import { useIssueDetailsPage } from '../apis';

export const IssueDetailsPage = () => {
  const { data } = useIssueDetailsPage();
  return (
    <>
      <MetaTags title="Issue Details | Devdynamics" />
      {data && data?.dto?.enabled ? (
        <MetricDetails />
      ) : (
        <ZeroStatePage
          data={data?.dto}
          featureAlert={data?.featureEnable === false ? true : false}
        />
      )}
    </>
  );
};
